import ArtistWatchPage from './ArtistWatchPage';
import ArtistWatchPageContainer from './ArtistWatchPage.container';

export default ArtistWatchPageContainer(ArtistWatchPage);
